/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kind_AllInputs */



/**
* | output |
* | --- |
* | "All conversations" |
*
* @param {Meetings_Kind_AllInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kind_all = /** @type {((inputs?: Meetings_Kind_AllInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kind_AllInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alle gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les conversations")
	return /** @type {LocalizedString} */ ("All conversations")
});